import React, { useState, useRef, useEffect } from "react";
import ReactQuill , { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import SideBar from "../../Components/Navbar/Sidebar";
import { gohBlogUpload } from "../../Components/Apis/apis";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";

const Link = Quill.import('formats/link');

class CustomLink extends Link {
  static create(value) {
    let node = super.create(value);
    node.setAttribute('rel', 'dofollow');
    return node;
  }
}

Quill.register(CustomLink, true);

const GohBlogs = () => {
  const allCategory = [
    { for: "gohoarding", cat: "Billboard", value: "billboard" },
    { for: "gohoarding", cat: "Digital billboard", value: "digital-billboard" },
    { for: "gohoarding", cat: "Mall media", value: "mall-media" },
    { for: "gohoarding", cat: "Inflight branding", value: "inflight-branding" },
    { for: "gohoarding", cat: "Lift branding", value: "lift-branding" },
    { for: "gohoarding", cat: "Transit media", value: "transit-media" },
    { for: "gohoarding", cat: "Airport branding", value: "airport-branding" },
    { for: "newgoh", cat: "Cinema", value: "cinema" },
    { for: "newgoh", cat: "Digital OOH", value: "digital-ooh" },
    { for: "newgoh", cat: "Magazine", value: "magazine" },
    { for: "newgoh", cat: "Newspaper", value: "newspaper" },
    { for: "newgoh", cat: "Radio", value: "radio" },
    { for: "newgoh", cat: "Sports", value: "sports" },
    { for: "newgoh", cat: "Television", value: "television" },
    { for: "pghive", cat: "For Woner", value: "for-woner" },
    { for: "pghive", cat: "For Tenant", value: "for-tenant" },
    { for: "influencer", cat: "For Client", value: "for-client" },
    { for: "influencer", cat: "For influencer", value: "for-influencer" },
  ];

  const [genratingImg, setGenratingImg] = useState(false);
  const [genratingBlog, setGenratingBlog] = useState(false);
  const [catOption, setCatOption] = useState([]);
  const [blogTitle, setBlogTitle] = useState("");
  const [blogUrl, setBlogUrl] = useState("");
  const [blogSummary, setBlogSummary] = useState("");
  const [blogKeywords, setBlogKeywords] = useState("");
  const [blogFor, setBlogFor] = useState("gohoarding");
  const [blogCategory, setBlogCategory] = useState("");
  const [blogImage, setBlogImage] = useState(null);
  const [blogContent, setBlogContent] = useState("");
  const fileInputRef = useRef(null);

  useEffect(() => {
    const filteredCategories = allCategory.filter(
      (category) => category.for === blogFor
    );
    setCatOption(filteredCategories);
  }, [blogFor]);

  const handleBoxClick = () => {
    fileInputRef.current.click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setBlogImage(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      blogImage &&
      blogTitle &&
      blogUrl &&
      blogFor &&
      blogCategory &&
      blogContent &&
      blogKeywords
    ) {
      const formData = new FormData();
      formData.append("image", blogImage);
      formData.append("title", blogTitle);
      formData.append("url", blogUrl);
      formData.append("blogFor", blogFor);
      formData.append("blogCategory", blogCategory);
      formData.append("summary", blogSummary);
      formData.append("keywords", blogKeywords);
      formData.append("content", blogContent);
      const data = await gohBlogUpload(formData);
      if (data.success === true) {
        toast(data.message);
        setBlogTitle("");
        setBlogUrl("");
        setBlogFor("");
        setBlogImage(null);
        setBlogContent("");
        setBlogCategory("");
        setBlogSummary("");
        setBlogKeywords("");
      } else {
        toast.error(data.message);
      }
    } else {
      alert("All fields required");
    }
  };

  const generateBlogtexts = async () => {
    if (!blogKeywords) {
      return toast.error("Please type keywords first");
    }
    setGenratingBlog(true);
    generateImage();
    
    const prompt = `Generate a Title, URL, summary (1 paragraph), and description (5 paragraphs with headings) related to ${blogKeywords}. For the URL, provide only the text in a format like "billboard-advertising" without the full URL like "www.advertising.com/billboard-advertising". Each paragraph in the description should be more detailed and have a more than 200 word count.`;
    try {
      const response = await axios.post(
        "https://openrouter.ai/api/v1/chat/completions",
        {
          model: "anthropic/claude-3-haiku:beta",
          messages: [{ role: "user", content: prompt }],
          temperature: 0.7,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.REACT_APP_OPENROUTER_KEY}`,
          },
        }
      );
      setGenratingBlog(false);
  
      if (response.data.choices && response.data.choices.length > 0) {
        const generatedText = response.data.choices[0].message.content;
        console.log(generatedText);
        const matches = generatedText.match(
          /Title:\s*(.*?)\s*URL:\s*(.*?)\s*Summary:\s*(.*?)\s*Description:\s*(.*)/s
        );
        if (matches) {
          const [, title, url, summary, content] = matches;
          setBlogTitle(title.trim());
          setBlogUrl(url.trim());
          setBlogSummary(summary.trim());
  
          const parts = content.split(/\n\s*\n/);
          let formattedContent = "";
  
          parts.forEach((part) => {
            const headingMatch = part.match(/^(.*?):\s*(.*)/s);
            if (headingMatch) {
              const heading = headingMatch[1].trim();
              const paragraph = headingMatch[2].trim();
              formattedContent += `<h3>${heading}:</h3><p>${paragraph}</p>`;
            } else {
              formattedContent += `<p>${part.trim()}</p>`;
            }
          });
  
          setBlogContent(formattedContent);
        } else {
          alert("Failed to extract data from generated prompt");
        }
      } else {
        alert("No response or invalid response from OpenAI.");
      }
    } catch (error) {
      console.error(
        "Error generating prompt:",
        error.response ? error.response.data : error.message
      );
      setGenratingBlog(false);
      setBlogTitle("");
      setBlogUrl("");
      setBlogSummary("");
      setBlogContent("");
    }
  };
  

  const generateImage = async () => {
    if (!blogKeywords) {
      return toast.error("Please type keywords first");
    }
    setBlogImage(null);
    setGenratingImg(true);
    const engineId = "stable-diffusion-v1-6";
    const apiHost = "https://api.stability.ai";

    if (!process.env.REACT_APP_STBLT_KEY)
      throw new Error("Missing Stability API key.");

    try {
      const response = await axios.post(
        `${apiHost}/v1/generation/${engineId}/text-to-image`,
        {
          text_prompts: [
            {
              text: `Find images related to ${blogKeywords}`,
              weight: 1,
            },
          ],
          clip_guidance_preset: "FAST_BLUE",
          sampler: "K_DPM_2_ANCESTRAL",
          cfg_scale: 7,
          height: 512,
          width: 512,
          steps: 30,
          samples: 1,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${process.env.REACT_APP_STBLT_KEY}`,
          },
        }
      );

      response.data.artifacts.forEach((image, index) => {
        const byteCharacters = atob(image.base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "image/png" });
        // Create a File object with .png extension
        const imageName = `image_${index}.png`;
        const file = new File([blob], imageName, { type: "image/png" });
        setGenratingImg(false);
        setBlogImage(file);
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <>
      <div className="containers">
        <div className="container-sidebar">
          <SideBar />
        </div>
        <div className="container-pages ">
          <div className="page-title">
            <h2>Upload blogs</h2>
          </div>

          <div className="row">
            <div className="col-8">
              <div className="form-group">
                <label htmlFor="blogTitle">Blog Title:</label>
                <input
                  type="text"
                  id="blogTitle"
                  className="form-control ms-0 mt-1"
                  value={blogTitle}
                  onChange={(e) => setBlogTitle(e.target.value)}
                  placeholder={
                    genratingBlog ? "Genrating..." : "Enter Blog Title"
                  }
                />
              </div>

              <div className="form-group">
                <label htmlFor="blogUrl">Blog URL:</label>
                <input
                  type="text"
                  id="blogUrl"
                  className="form-control ms-0 mt-1"
                  value={blogUrl}
                  onChange={(e) => setBlogUrl(e.target.value)}
                  placeholder={
                    genratingBlog ? "Genrating..." : "Enter Blog URL"
                  }
                />
              </div>
              <div className="form-group">
                <label htmlFor="blogSummary">
                  Summary & Description (Meta Tag):
                </label>
                <textarea
                  id="blogSummary"
                  className="form-control ms-0 mt-1"
                  value={blogSummary}
                  onChange={(e) => setBlogSummary(e.target.value)}
                  rows={3}
                  placeholder={
                    genratingBlog ? "Genrating..." : "Enter Blog Summary"
                  }
                />
              </div>

              <div className="form-group mt-2">
                <label htmlFor="blogUrl">Keywords (Meta Tag):</label>
                <input
                  type="text"
                  id="blogUrl"
                  className="form-control ms-0 mt-1"
                  value={blogKeywords}
                  onChange={(e) => setBlogKeywords(e.target.value)}
                  placeholder="Enter Keywords"
                />
                <button
                  disabled={genratingBlog}
                  className="btn btn-success mt-1"
                  onClick={generateBlogtexts}
                >
                  {genratingBlog ? (
                    <div className="d-flex">
                      <div
                        className="spinner-grow spinner-grow-sm ms-2"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                      <div
                        className="spinner-grow spinner-grow-sm ms-2 me-2"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                      <div
                        className="spinner-grow spinner-grow-sm  me-2"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    "Generate Blog"
                  )}{" "}
                </button>
              </div>
            </div>
            <div className="col-4 ps-5">
              <div className="form-group">
                <label htmlFor="blogUrl">Blog For:</label>
                <select
                  id="blogUrl"
                  className="form-select ms-0  w-75 mt-1"
                  value={blogFor}
                  onChange={(e) => setBlogFor(e.target.value)}
                >
                  <option value="gohoarding" selected>
                    Gohoarding
                  </option>
                  <option value="newgoh">New Goh</option>
                  <option value="pghive">PG Hive</option>
                  <option value="influencer">InfluencerSea</option>
                </select>
              </div>
              <div className="form-group mt-3">
                <label htmlFor="blogUrl">Ctegory:</label>
                <select
                  id="blogUrl"
                  className="form-select ms-0  w-75 mt-1"
                  value={blogCategory}
                  onChange={(e) => setBlogCategory(e.target.value)}
                >
                  <option value="" selected disabled></option>
                  {catOption.map((option, index) => (
                    <option key={index} value={option.value}>
                      {option.cat}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group mt-3">
                <label htmlFor="blogImage">Blog Image:</label>
                <div className="image-upload-box mt-1" onClick={handleBoxClick}>
                  {genratingImg ? (
                    <div className="d-flex">
                      <div
                        className="spinner-grow spinner-grow-sm"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                      <div
                        className="spinner-grow spinner-grow-sm ms-2 me-2"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                      <div
                        className="spinner-grow spinner-grow-sm"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <>
                      {blogImage ? (
                        <img
                          src={URL.createObjectURL(blogImage)}
                          alt="Blog"
                          style={{ width: "180px", height: "120px" }}
                        />
                      ) : (
                        <span>Click to select image</span>
                      )}
                    </>
                  )}
                </div>
                <input
                  type="file"
                  id="blogImage"
                  accept=".jpg, .png"
                  onChange={handleImageChange}
                  ref={fileInputRef}
                  style={{ display: "none" }}
                />
              </div>
              <button className="btn btn-success mt-2" onClick={generateImage}>
                Generate Image
              </button>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="blogContent" className="mb-1">
              Blog Content:
            </label>
            <ReactQuill
              id="blogContent"
              value={blogContent}
              onChange={setBlogContent}
              placeholder={
                genratingBlog ? "Genrating..." : "Enter Blog Content"
              }
              style={{ backgroundColor: "white" }}
            />
          </div>

          <div className="col-12 text-center">
            <div>
              <button
                onClick={handleSubmit}
                className="btn btn-info text-light w-25 mt-3"
              >
                Upload
              </button>
              <ToastContainer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GohBlogs;
